import {Entity} from "./ecs/entity/Entity";

export const castEntity = <T>
    (entity: Entity<T | any>) => entity as Entity<T>;

export const castEntityFull = <T extends Entity<any>>
    (entity: Entity<T | any>) => entity as T;
